import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CandidacyStatusChange, HttpResponse } from "@/types";

export function useGetCandidacyStatusChanges({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "candidacy_status_changes",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/candidacy_status_changes`;
      const res = await guacHttpClient.get<
        CandidacyStatusChange[],
        HttpResponse<CandidacyStatusChange[]>
      >(path);
      return res.data;
    },
  });
}
